export default __webpack_public_path__ + "static/media/poster2.0c9ad5c8.png";